import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';
export default {
  computed: {
    definition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    }
  },
  mixins: [baseCrudMixin],
  data: () => ({
    entity: 'LinkDomainDeliveryPrice',
    returnTo: 'Domains'
  }),
  created() {
    // This already gets loaded by pricelistitems\index.vue.
    // this.$store.dispatch('priceListItem/getItems', {
    //   query: { domainid: this.$route.params.id }
    // });
    this.$store.dispatch('country/getItems');
  },
  methods: {
    getDependencies(data) {
      return [];
    },
    createDefinition() {
      return getFormDefinition(this);
    },
    createFormDataFromItem,
    createItemFromFormData
  }
};
